var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_info",staticStyle:{"width":"100%","height":"100%"}},[_c('video',{staticClass:"video-js",attrs:{"id":_vm.videoId,"muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }